import React from "react";
import Canada from "./Images/Canada";
import Bulgaria from "./Images/Bulgaria";
import Usa from "./Images/Usa";
import Colombia from "./Images/Colombia";
import Brasil from "./Images/Brasil";
import Cyprus from "./Images/Cyprus";
import Greece from "./Images/Greece";
import Hungary from "./Images/Hungary";
import Salvador from "./Images/Salvador";
import Paraguay from "./Images/Paraguay";
import Switzerland from "./Images/Switzerland";
import Mexico from "./Images/Mexico";
import Germany from "./Images/Germany";
import Slovenia from "./Images/Slovenia";
import Estonia from "./Images/Estonia";
import Argentina from "./Images/Argentina";
import Luxembourg from "./Images/Luxembourg";
import Chile from "./Images/Chile";
import Cioff from "./Images/Cioff";
import Kyrgyzstan from "./Images/Kyrgyzstan";
import Israel from "./Images/Israel";
import Italy from "./Images/Italy";
import Bolivia from "./Images/Bolivia";
import France from "./Images/France";
import Pakistan from "./Images/Pakistan";
import Indonesia from "./Images/Indonesia";
import Turkey from "./Images/Turkey";
import CostaRica from "./Images/CostaRica";

const components = {
  argentina: Argentina,
  bolivia: Bolivia,
  brasil: Brasil,
  bulgaria: Bulgaria,
  canada: Canada,
  chile: Chile,
  cioff: Cioff,
  colombia: Colombia,
  cyprus: Cyprus,
  estonia: Estonia,
  france: France,
  germany: Germany,
  greece: Greece,
  hungary: Hungary,
  indonesia: Indonesia,
  israel: Israel,
  italy: Italy,
  kyrgyzstan: Kyrgyzstan,
  luxembourg: Luxembourg,
  mexico: Mexico,
  pakistan: Pakistan,
  paraguay: Paraguay,
  salvador: Salvador,
  slovenia: Slovenia,
  switzerland: Switzerland,
  usa: Usa,
  turkey: Turkey,
  costaRica: CostaRica,
};

export default function ColoredInImage(props) {
  const ColorImage = components[props.component];

  return (
    <ColorImage
      id="svg-image"
      onFill={props.onFill}
      fillColors={props.fillColors}
      {...props}
    />
  );
}
